import { Pause, PlayArrow, VolumeOff, VolumeUp } from "@mui/icons-material";
import { Slider, useTheme } from "@mui/material";
import React, { useRef } from "react";
import "../App.css";

import useVideoPlayer from "../hook/useVideoPlayer";

const VideoPlayer = (videoUrl) => {
    const videoElement = useRef(null);
    const theme = useTheme();
    const {
        playerState,
        togglePlay,
        handleOnTimeUpdate,
        handleVideoProgress,
        handleVideoSpeed,
        toggleMute,
    } = useVideoPlayer(videoElement);

    return (
        <div className="container">
            <div className="video-wrapper">
                <video
                    src={videoUrl.videoUrl}
                    ref={videoElement}
                    onTimeUpdate={handleOnTimeUpdate}
                    autoplay={true}
                />
                <div className="controls">
                    <div className="actions">
                        <button onClick={togglePlay} style={{marginRight: 4}}>
                            {!playerState.isPlaying ? (
                                <PlayArrow style={{marginTop: 7, color: '#eca914'}} />
                            ) : (
                                <Pause style={{marginTop: 7, color: '#eca914'}} />
                            )}
                        </button>
                    </div>
                    <Slider
                        sx={{
                            '& .MuiSlider-thumb': {
                                width: 8,
                                height: 8,
                                marginTop: 0,
                                marginLeft: 0,
                                transition: '0.3s cubic-bezier(.47,1.64,.41,.8)',
                                '&:before': {
                                    boxShadow: '0 2px 12px 0 rgba(0,0,0,0.4)',
                                },
                                '&:hover, &.Mui-focusVisible': {
                                    boxShadow: `0px 0px 0px 8px ${
                                        theme.palette.mode === 'dark'
                                            ? 'rgb(255 255 255 / 16%)'
                                            : 'rgb(0 0 0 / 16%)'
                                    }`,
                                },
                                '&.Mui-active': {
                                    width: 20,
                                    height: 20,
                                },
                            },
                            '& .MuiSlider-rail': {
                                opacity: 0.28,
                            },
                        }}
            
                        style={{color: '#ECA914', maxWidth: 350}}
                        value={playerState.progress}
                        onChange={(e) => handleVideoProgress(e)}
                    />
                    <select
                        className="velocity"
                        value={playerState.speed}
                        onChange={(e) => handleVideoSpeed(e)}
                    >
                        <option style={{margin: 10}} value="0.50">0.50x</option>
                        <option style={{margin: 10}} value="1">1x</option>
                        <option style={{margin: 10}} value="1.25">1.25x</option>
                        <option style={{margin: 10}} value="2">2x</option>
                    </select>
                    <button className="mute-btn" onClick={toggleMute}>
                        {!playerState.isMuted ? (
                            <VolumeUp style={{marginTop: 7, color: '#eca914'}}/>
                        ) : (
                            <VolumeOff style={{marginTop: 7, color: '#eca914'}}/>
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default VideoPlayer;